module.exports = __webpack_public_path__ + "assets/3d54aa5f3e1c89eb6ba8961ec2f3e6d9.png";